/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tabs_Related1Inputs */

const id_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkait`)
};

const ms_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berkaitan`)
};

const da_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relateret`)
};

const de_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandt`)
};

const en_us2_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related`)
};

const es_es2_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado`)
};

const es_mx2_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado`)
};

const fil_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaugnay`)
};

const fr_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liés`)
};

const it_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correlati`)
};

const hu_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolódó`)
};

const nl_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerelateerd`)
};

const no_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatert`)
};

const pl_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiązane`)
};

const pt_br2_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado`)
};

const pt_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionados`)
};

const ro_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înrudite`)
};

const fi_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liittyvät`)
};

const sv_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaterat`)
};

const vi_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên quan`)
};

const tr_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlgili`)
};

const cs_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Související`)
};

const bg_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свързани`)
};

const ru_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанное`)
};

const uk_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пов'язане`)
};

const ar_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذات صلة`)
};

const hi_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संबंधित`)
};

const th_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่เกี่ยวข้อง`)
};

const ja_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連`)
};

const zh_cn2_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关内容`)
};

const zh_hant1_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相關內容`)
};

const ko_offerdetail_tabs_related1 = /** @type {(inputs: Offerdetail_Tabs_Related1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관련`)
};

/**
* | output |
* | --- |
* | "Related" |
*
* @param {Offerdetail_Tabs_Related1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tabs_related1 = /** @type {((inputs?: Offerdetail_Tabs_Related1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tabs_Related1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tabs_related1(inputs)
	if (locale === "ms") return ms_offerdetail_tabs_related1(inputs)
	if (locale === "da") return da_offerdetail_tabs_related1(inputs)
	if (locale === "de") return de_offerdetail_tabs_related1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tabs_related1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tabs_related1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tabs_related1(inputs)
	if (locale === "fil") return fil_offerdetail_tabs_related1(inputs)
	if (locale === "fr") return fr_offerdetail_tabs_related1(inputs)
	if (locale === "it") return it_offerdetail_tabs_related1(inputs)
	if (locale === "hu") return hu_offerdetail_tabs_related1(inputs)
	if (locale === "nl") return nl_offerdetail_tabs_related1(inputs)
	if (locale === "no") return no_offerdetail_tabs_related1(inputs)
	if (locale === "pl") return pl_offerdetail_tabs_related1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tabs_related1(inputs)
	if (locale === "pt") return pt_offerdetail_tabs_related1(inputs)
	if (locale === "ro") return ro_offerdetail_tabs_related1(inputs)
	if (locale === "fi") return fi_offerdetail_tabs_related1(inputs)
	if (locale === "sv") return sv_offerdetail_tabs_related1(inputs)
	if (locale === "vi") return vi_offerdetail_tabs_related1(inputs)
	if (locale === "tr") return tr_offerdetail_tabs_related1(inputs)
	if (locale === "cs") return cs_offerdetail_tabs_related1(inputs)
	if (locale === "bg") return bg_offerdetail_tabs_related1(inputs)
	if (locale === "ru") return ru_offerdetail_tabs_related1(inputs)
	if (locale === "uk") return uk_offerdetail_tabs_related1(inputs)
	if (locale === "ar") return ar_offerdetail_tabs_related1(inputs)
	if (locale === "hi") return hi_offerdetail_tabs_related1(inputs)
	if (locale === "th") return th_offerdetail_tabs_related1(inputs)
	if (locale === "ja") return ja_offerdetail_tabs_related1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tabs_related1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tabs_related1(inputs)
	return ko_offerdetail_tabs_related1(inputs)
});
export { offerdetail_tabs_related1 as "offerDetail.tabs.related" }